window.addEventListener("load", () => {
  if (window.localStorage.getItem("wishlist-refresh")) {
    document.querySelector("cart-notification").open();
    window.localStorage.removeItem("wishlist-refresh");
  }
});

document.addEventListener(
  "click",
  function (t) {
    if (!t.target.closest("#mini-cart-drawer")) return;
    if (t.target && 1 == t.target.hasAttribute("data-hulksaveforlater")) {
      t.preventDefault();
      t.stopImmediatePropagation;
      t.stopPropagation();
      var e = t.target,
        s = e.getAttribute("data-product-id"),
        l = e.getAttribute("data-variant-id"),
        i = e.getAttribute("data-line"),
        o = e.parentElement.parentElement,
        a =
          showQuantitySection &&
          null != o.querySelector('input[name="updates[]"]')
            ? o.querySelector('input[name="updates[]"]').value
            : null;
      if (
        "Customer" == customerStatus &&
        1 == WishlistSettings.general.has_multiple_wishlist
      )
        modalBody &&
          skeletonLoader &&
          ((modalBody[2].style.display = "none"),
          (skeletonLoader.style.display = "block")),
          HulkappWishlist._updateWishlistSelection(s, l),
          setTimeout(function () {
            (searchWishlist = ""),
              (document.querySelector("[data-wishlistsearch]").value = ""),
              HulkappWishlist._getUserWishlist(!0),
              document
                .querySelectorAll("[data-hulkappsWishlistPopup]")[0]
                .classList.add("open"),
              document
                .querySelectorAll("[data-addtowishlist]")[0]
                .setAttribute("hulk_saveForLater", i),
              document
                .querySelectorAll("[data-addtowishlist]")[0]
                .setAttribute("hulk_saveForLater_itemQty", a),
              (wishlistButtonTarget = e),
              document.body.classList.add("hulkapps__popup__active");
          }, 300);
      else if (
        1 == WishlistSettings.general.is_guest_enabled ||
        "Customer" == customerStatus
      )
        HulkappWishlist._addToWishlist(e, s, l, DefaultWishlistID, a, !0),
          e.setAttribute("class", "addtoWishlist"),
          setTimeout(function () {
            var t = {
              line: i,
              quantity: 0,
            };
            fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(t),
            }).then(function (t) {
              var e = document.getElementById("CartDrawer");
              //window.location.href = e ? proxyURL : "/cart"
            });
          }, 1500);
      else {
        var n =
          WishlistSettings.language.success_message.for_guest_login_disabled;
        HulkappWishlist._messageUpdate(n);
      }
      t.target.classList.remove("addtoWishlist");
      t.target.classList.add("icon-wishlist-heart");
      t.target.setAttribute("style", "color:red!important");
      t.target.removeAttribute("data-hulksaveforlater");
      setTimeout(() => {
        window.localStorage.setItem("wishlist-refresh", "true");
        window.location.reload();
      }, 2500);
    }
  },
  !0
);
